import React from 'react';
import { RowInfo } from 'react-table';
import { appRoles } from '../../core/security/const';
import Translate from '../shared/localization/localize';
import Ellipsis from '../shared/ellipsis';
import LinkText from '../shared/linkText';
import * as Devices from '../../modules/devices';
import * as DT from '../../modules/datatable';
import { initDialog } from '../../modules/dialogs/deviceInfo/actions';
import { getPK } from '../../modules/devices';
import { hasRole } from '../../libs/security/utils';

interface Props {
  content: JSX.Element | string;
  onClick: () => void;
}

const ClickableText: React.FC<Props> = (props: Props) => (
  <LinkText
    style={{ display: 'block' }}
    onClick={props.onClick}
    content={props.content}
  />
);

export const getTrProps = (
  isSelected: DT.IsItemSelectedType<Devices.Device>
) => (state: any, rowInfo: RowInfo) => {
  let className = '';
  if (rowInfo) {
    if (!rowInfo.original.isActive) className += ' removed_record';
    if (isSelected(rowInfo.original)) className += ' selected-record';
  }

  return { className };
};
export const getColumns = (userRoles: string[]) => {
  const columnDefinitions: DT.TableColumn[] = [
    {
      Header: <Translate message={Devices.msgSN} />,
      id: 'serialNumber',
      minWidth: 125,
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{Devices.getSNLabel(o)}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: false,
      defaultShow: true,
    },
    {
      Header: <Translate message={Devices.msgKId} />,
      id: 'kamstrupId',
      minWidth: 125,
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={getPK(o)}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: false,
    },
    {
      Header: <Translate message={Devices.msgNumericalId} />,
      id: 'numericalIdentity',
      minWidth: 125,
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{o.numericalIdentity}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: false,
    },
    {
      Header: <Translate message={Devices.msgCDMN} />,
      id: 'customerDeviceNo',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{o.customerDeviceNo}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: false,
    },
    {
      Header: <Translate message={Devices.msgOrder} />,
      id: 'orderNumber',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{Devices.displayOrderNo(o)}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: true,
    },
    {
      Header: <Translate message={Devices.msgStatus} />,
      id: 'isActive',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={
            <Ellipsis>
              <Translate message={Devices.msgStatusValue(o.isActive)} />
            </Ellipsis>
          }
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: false,
    },
    {
      Header: <Translate message={Devices.msgDeviceType} />,
      id: 'deviceType',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={
            <Ellipsis>
              <Translate message={Devices.DeviceTypeNames[o.deviceType]} />
            </Ellipsis>
          }
          onClick={() => initDialog(getPK(o))}
        />
      ),
      sortable: false,
      customizable: true,
      defaultShow: false,
    },
    {
      Header: <Translate message={Devices.msgDeviceName} />,
      id: 'deviceName',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{o.deviceName}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: true,
    },
    {
      Header: <Translate message={Devices.msgOwner} />,
      id: 'owner',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{o.owner}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: !hasRole(userRoles, [appRoles.user, appRoles.superuser]),
    },
    {
      Header: <Translate message={Devices.msgReadRights} />,
      id: 'userWithReadRights',
      accessor: (o: Devices.Device) => (
        <ClickableText
          content={<Ellipsis>{o.userWithReadRights}</Ellipsis>}
          onClick={() => initDialog(getPK(o))}
        />
      ),
      customizable: true,
      defaultShow: !hasRole(userRoles, [appRoles.user]),
    },
  ];

  return DT.initColumnsVisibility(columnDefinitions);
};
